import React, { useState } from 'react';
import './ShareDialog.css';

const ShareDialog = ({ isOpen, onClose, product }) => {
  const [copied, setCopied] = useState(false);

  if (!isOpen || !product) return null;

  const productUrl = `${window.location.origin}/product/${product.product_ID}`;
  const productTitle = product.product_title || 'Check out this product';
  const productPrice = product.product_price || '';
  const productImage = product.product_image_1 || '';

  const shareText = `${productTitle}\nPrice: ₹${productPrice}\nCheck it out: ${productUrl}`;

  const shareOptions = [
    {
      name: 'WhatsApp',
      icon: 'fab fa-whatsapp',
      color: '#25D366',
      url: `https://wa.me/?text=${encodeURIComponent(shareText)}`
    },
    {
      name: 'Facebook',
      icon: 'fab fa-facebook-f',
      color: '#1877F2',
      url: `https://www.facebook.com/sharer/sharer.php?u=${encodeURIComponent(productUrl)}`
    },
    {
      name: 'Twitter',
      icon: 'fab fa-twitter',
      color: '#1DA1F2',
      url: `https://twitter.com/intent/tweet?text=${encodeURIComponent(shareText)}`
    },
    {
      name: 'Telegram',
      icon: 'fab fa-telegram-plane',
      color: '#0088CC',
      url: `https://t.me/share/url?url=${encodeURIComponent(productUrl)}&text=${encodeURIComponent(productTitle)}`
    },
    {
      name: 'LinkedIn',
      icon: 'fab fa-linkedin-in',
      color: '#0A66C2',
      url: `https://www.linkedin.com/sharing/share-offsite/?url=${encodeURIComponent(productUrl)}`
    },
    {
      name: 'Pinterest',
      icon: 'fab fa-pinterest-p',
      color: '#BD081C',
      url: `https://pinterest.com/pin/create/button/?url=${encodeURIComponent(productUrl)}&media=${encodeURIComponent(productImage)}&description=${encodeURIComponent(productTitle)}`
    }
  ];

  const handleShare = (shareUrl) => {
    window.open(shareUrl, '_blank', 'width=600,height=400');
  };

  const handleCopyLink = async () => {
    try {
      await navigator.clipboard.writeText(productUrl);
      setCopied(true);
      setTimeout(() => setCopied(false), 2000);
    } catch (error) {
      // Fallback for older browsers
      const textArea = document.createElement('textarea');
      textArea.value = productUrl;
      document.body.appendChild(textArea);
      textArea.select();
      document.execCommand('copy');
      document.body.removeChild(textArea);
      setCopied(true);
      setTimeout(() => setCopied(false), 2000);
    }
  };

  const handleNativeShare = async () => {
    if (navigator.share) {
      try {
        await navigator.share({
          title: productTitle,
          text: `Check out this product: ${productTitle}`,
          url: productUrl
        });
      } catch (error) {
        console.log('Error sharing:', error);
      }
    }
  };

  return (
    <div className="share-dialog-overlay" onClick={onClose}>
      <div className="share-dialog" onClick={e => e.stopPropagation()}>
        <div className="share-dialog-header">
          <h3>Share Product</h3>
          <button className="close-btn" onClick={onClose}>
            <i className="fas fa-times"></i>
          </button>
        </div>

        <div className="share-dialog-content">
          {/* Product Preview */}
          <div className="product-preview">
            <img 
              src={productImage} 
              alt={productTitle}
              className="preview-image"
            />
            <div className="preview-info">
              <h4>{productTitle}</h4>
              <p className="preview-price">₹{productPrice}</p>
            </div>
          </div>

          {/* Share Options */}
          <div className="share-options">
            <h4>Share via</h4>
            <div className="share-buttons-grid">
              {shareOptions.map(option => (
                <button
                  key={option.name}
                  className="share-button"
                  onClick={() => handleShare(option.url)}
                  style={{ '--share-color': option.color }}
                >
                  <i className={option.icon}></i>
                  <span>{option.name}</span>
                </button>
              ))}
            </div>
          </div>

          {/* Native Share (Mobile) */}
          {navigator.share && (
            <div className="native-share">
              <button className="native-share-btn" onClick={handleNativeShare}>
                <i className="fas fa-share-alt"></i>
                <span>More sharing options</span>
              </button>
            </div>
          )}

          {/* Copy Link */}
          <div className="copy-link-section">
            <h4>Or copy link</h4>
            <div className="copy-link-container">
              <input
                type="text"
                value={productUrl}
                readOnly
                className="link-input"
              />
              <button 
                className={`copy-btn ${copied ? 'copied' : ''}`}
                onClick={handleCopyLink}
              >
                <i className={`fas ${copied ? 'fa-check' : 'fa-copy'}`}></i>
                {copied ? 'Copied!' : 'Copy'}
              </button>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default ShareDialog;
